module.exports = __webpack_public_path__ + "img/section2.ac1027e6.png";